import useLocalStorageState from 'use-local-storage-state';

export function useCommentDraftState() {
  return useLocalStorageState('commentDrafts');
}
